import { PostFormRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { CouponEntity } from "../../Objects/Coupon/CouponEntity"
import { ERequestType } from "../../Enum/ERequestType"
import { useLoad } from "../../context/useLoadContext"
import { useError } from "../../context/useErrorContext"
import { useTranslation } from "react-i18next"

export const useValidateCoupon = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleValidateCoupon = async (code: string): Promise<CouponEntity | null> => {
    enableLoad()

    try {
      const response = await PostFormRequest<CouponEntity>(API_ROUTES.COUPON.VALIDATE, { code }, ERequestType.Customer)

      if (!response.success) {
        return null
      }

      return response.data ? new CouponEntity(response.data) : null
    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleValidateCoupon,
  }
}
